import {
  OuiCenterComponent,
  OuiProgressGaugeComponent,
  OuiRowComponent,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, input } from '@angular/core';
import { css } from '@emotion/css';

@Component({
  selector: 'app-card',
  imports: [
    OuiTextComponent,
    OuiStackComponent,
    OuiRowComponent,
    OuiCenterComponent,
    OuiProgressGaugeComponent,
  ],
  templateUrl: './card.component.html',
})
export class CardComponent {
  headline = input<string | null>(null);
  loading = input<boolean>(false);
  loadingError = input<boolean>(false);
  loadingProgress = input<number | undefined>();
  loadingMessage = input<string | undefined>();

  loadingOverlayClass = css({
    animation: 'fadeIn 350ms ease-in-out',

    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
      },
      '100%': {
        opacity: 1,
      },
    },
  });
}
